import { useContext } from "react"
import BackfillReportableFieldContext from "../BackfillReportableFieldContext"

const useBackfillReportableFieldContext = () => {
  const providedValue = useContext(BackfillReportableFieldContext)

  return { ...providedValue }
}

export default useBackfillReportableFieldContext
